// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Tooltip } from "../../../revvComponents";

// Components Imports
import AssetDetailsPopupWrapper from "../../AssetDetailsPopupWrapper";
import AssetsOpportunityItem from "../AssetsOpportunityItem";
import CreateDocPopup from "../../CreateDocPopup";
import withRbac from "../../../app/withRbac";

// Internal Imports
import { PERMISSIONS, EVENTS } from "../../../constants";
import { AmplitudeUtils } from "../../../utils";

class AssetsOpportunity extends Component {
  assetDetailDropdownRef = React.createRef();

  state = {
    showAssetDetailsPopup: false,
    showCreateDocumentPopup: false,
  };

  _toggleAssetDetailsPopup = () => {
    // attach an event listener when onhover
    if (!this.state.showAssetDetailsPopup) {
      document.addEventListener(
        "mouseover",
        this._handleAssetDetailDropdownOutsideClick,
        false,
      );
      this.setState({
        showAssetDetailsPopup: true,
      });
    }
  };

  // --------- Create Document related methods start here -------------
  _openCreateDocumentPopup = () => {
    this.setState(() => ({
      // openOpportunity: opportunity,
      showCreateDocumentPopup: true,
    }));
  };

  _closeCreateDocumentPopup = () => {
    this.setState({
      showCreateDocumentPopup: false,
    });
  };

  // -------- Document related methods end here ----------------

  _handleAssetDetailDropdownOutsideClick = e => {
    const node = this.assetDetailDropdownRef.current;
    // ignore clicks on the component itself
    if (node && node.contains(e.target)) {
      return;
    }
    this.setState({
      showAssetDetailsPopup: false,
    });

    // remove an event listener when onhover
    document.removeEventListener(
      "mouseover",
      this._handleAssetDetailDropdownOutsideClick,
      false,
    );
  };

  render() {
    const {
      crm_opportunity: {
        name: oppoName,
        stage_name: oppoStage,
        is_closed: isOppoClosed,
      } = {},
      documents,
      documentTypes,
    } = this.props;
    const opportunityData = { ...this.props.crm_opportunity };
    opportunityData.crm_account = { ...this.props.selectedAccount };
    const { showCreateDocumentPopup } = this.state;

    const popupSpace = (
      <CreateDocPopup
        opportunity={this.props.crm_opportunity}
        show={showCreateDocumentPopup}
        closePopup={this._closeCreateDocumentPopup}
        documentTypes={documentTypes}
        source="Asset"
      />
    );

    // check the create document permission
    const CreateDocumentBtn = withRbac(() => (
      <span
        className="assetsopportunity-createdoc-iconwrapper"
        onClick={() => {
          this._openCreateDocumentPopup(this.props.crm_opportunity);
          AmplitudeUtils.amplitudeLogEvent(
            EVENTS.EVENT_NAMES.CREATE_DOC_CLICKED,
            { initiatedFrom: "Asset" },
          );
        }}
        onKeyPress={() => {}}
        role="button"
        tabIndex="0">
        Create document
      </span>
    ));

    return (
      <Fragment>
        {showCreateDocumentPopup && popupSpace}

        <div className="assetsopportunity-card">
          {/* Assets Opportunity Card Header */}
          <div className="assetsopportunity-card-header">
            <span className="assetsopportunity-opps-icon">
              <FontAwesomeIcon icon={["fas", "crown"]} />
            </span>
            <div className="assetsopportunity-ch-leftsec">
              <p className="assetsopportunity-oppname">
                {oppoName}
                <span
                  className={`more-btn ${
                    this.state.showAssetDetailsPopup
                      ? "assetsopportunity-active-title"
                      : ""
                  }`}
                  onMouseOver={this._toggleAssetDetailsPopup}
                  onFocus={this._toggleAssetDetailsPopup}
                  role="button"
                  tabIndex="0">
                  <i>
                    <FontAwesomeIcon icon={["far", "ellipsis-h"]} />
                  </i>
                </span>
              </p>
              <p className="assetsopportunity-documents">
                {documents.length} Document{documents.length > 1 && "s"}
              </p>
            </div>
            <div className="assetsopportunity-ch-rightsec">
              <Tooltip
                placement="top"
                align={{
                  offset: [0, 4],
                }}
                overlay="Status of the opportunity from your CRM">
                <div className="assetsopportunity-status">
                  <span>{oppoStage}</span>
                </div>
              </Tooltip>
              {!isOppoClosed &&
                this.props.crm_opportunity.scope &&
                this.props.crm_opportunity.scope.write && (
                  <CreateDocumentBtn
                    permission={PERMISSIONS.PIPELINE.CREATE_DEALS}
                  />
                )}
            </div>

            <AssetDetailsPopupWrapper
              opportunity={opportunityData}
              show={this.state.showAssetDetailsPopup}
              assetDetailDropdownRef={this.assetDetailDropdownRef}
              positionClassName="assetsopportunity-assetdetailpopup-position"
            />
          </div>

          {/* Assets Opportunity Documents list */}
          <div className="assetsopportunity-card-bodywrapper">
            {documents.map(document => (
              <AssetsOpportunityItem key={document.doc_no} {...document} />
            ))}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default connect(null)(AssetsOpportunity);
